module.exports = __webpack_public_path__ + "static/media/prop-10@2x-thumb.b37f67af.webp";